import { routing } from '@/i18n/routing';

export function isHomePathname(pathname: string | null | undefined) {
  if (!pathname) return false;
  const normalized = pathname === '/' ? pathname : pathname.replace(/\/+$/, '');
  if (normalized === '/') return true;
  return routing.locales.some((locale) => normalized === `/${locale}`);
}
